import React from "react";

const Pagination = ({ currentPage, totalPages, onPageClick, onNextClick }) => {
  // Function to generate visible page numbers with "..." and last page
  const generatePageNumbers = () => {
    let pages = [];

    if (totalPages <= 3) {
      // Show all pages if total pages are 3 or less
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            className={`page-btn ${currentPage === i ? "current-page" : ""}`}
            onClick={() => onPageClick(i)}
          >
            {i}
          </button>
        );
      }
    } else {
      // Always show the first page
      pages.push(
        <button
          key={1}
          className={`page-btn ${currentPage === 1 ? "current-page" : ""}`}
          onClick={() => onPageClick(1)}
        >
          1
        </button>
      );

      // Show the next two pages after the first page if applicable
      for (let i = 2; i <= Math.min(3, totalPages); i++) {
        pages.push(
          <button
            key={i}
            className={`page-btn ${currentPage === i ? "current-page" : ""}`}
            onClick={() => onPageClick(i)}
          >
            {i}
          </button>
        );
      }

      // Add "..." if there are more pages beyond the first three
      if (totalPages > 3 && currentPage < totalPages - 1) {
        pages.push(
          <span key="ellipsis" className="ellipsis">
            ...
          </span>
        );
      }

      // Always show the last page
      pages.push(
        <button
          key={totalPages}
          className={`page-btn ${currentPage === totalPages ? "current-page" : ""}`}
          onClick={() => onPageClick(totalPages)}
        >
          {totalPages}
        </button>
      );
    }

    return pages;
  };

  return (
    <div className="pagination-controls">
      {/* Page Buttons */}
      {generatePageNumbers()}

      {/* Next Button */}
      <button
        className="next-btn"
        onClick={onNextClick}
        disabled={currentPage === totalPages}
      >
        Next
        <img src="/images/nextpg.svg" alt="Next Arrow" />
      </button>
    </div>
  );
};

export default Pagination;

// import React from 'react';

// const Pagination = ({ currentPage, totalPages, onPageClick, onNextClick }) => {
//   const generatePageNumbers = () => {
//     let pages = [];
//     for (let i = 1; i <= totalPages; i++) {
//       pages.push(
//         <button 
//           key={i} 
//           className={`page-btn ${currentPage === i ? 'current-page' : ''}`} 
//           onClick={() => onPageClick(i)}
//         >
//           {i}
//         </button>
//       );
//     }
//     return pages;
//   };

//   return (
//     <div className="pagination-controls">
//       {generatePageNumbers()}
//       <button 
//         className="next-btn" 
//         onClick={onNextClick} 
//         disabled={currentPage === totalPages}
//       >
//         Next
//         <img src="/images/nextpg.svg" alt="Next Arrow"/>
//       </button>
//     </div>
//   );
// };


// export default Pagination;